/*  MUI  */
import { Box, Button } from '@mui/material';

/*  React  */
import React, { Component } from 'react';
import { withRouter } from 'router/withRouter';

class Mock extends Component {
    handleLogin = () => {
        const { report } = this.props;
        this.redirect(!!report);
    };

    redirect = (toReports = false) => {
        const { navigate, id, match, page } = this.props;
        const { partnerId } = match.params;

        if (toReports) {
            navigate(`/partner/${partnerId}/dashboard?clientId=${id}`);
            return;
        }

        navigate(`/partner/${partnerId}/admin/${id}/${page || ''}`);
    };

    render() {
        const { children, button, size } = this.props;

        if (button) {
            return (
                <Button
                    color="primary"
                    variant="contained"
                    size={size || 'medium'}
                    onClick={(e) => {
                        e.preventDefault();
                        this.handleLogin();
                    }}
                >
                    {children}
                </Button>
            );
        }

        return (
            <Box
                as="a"
                onClick={() => this.handleLogin()}
                className="link"
                aria-hidden="true"
            >
                {children}
            </Box>
        );
    }
}

export default withRouter(Mock);
